import Vue from "vue";
import VueRouter from "vue-router";
import AdminLayout from "../layout/AdminLayout";
import AdminEducationLayout from "../layout/AdminEducationLayout";
import SchoolLayout from "../layout/SchoolLayout";
import SchoolEducationLayout from "../layout/SchoolEducationLayout";
import AdminScriptLayout from "../layout/AdminScriptLayout";
import AdminTrainLayout from "../layout/AdminTrainLayout";
import AdminTaskLayout from "../layout/AdminTaskLayout";
import AdminHelpLayout from "../layout/AdminHelpLayout";
import StudentLayout from "../layout/StudentLayout.vue";
import TeacherLayout from "../layout/TeacherLayout";
import CompanyLayout from "../layout/CompanyLayout";
import StudentShortLayout from "../layout/StudentShortLayout.vue";
import TeacherShortLayout from "../layout/TeacherShortLayout";
import CompanyShortLayout from "../layout/CompanyShortLayout";
import StudentScriptLayout from "../layout/StudentScriptLayout";
import StudentDataLayout from "../layout/StudentDataLayout";
import CompanyViewLayout from "../layout/CompanyViewLayout";
import AdminScriptViewLayout from "../layout/AdminScriptViewLayout";
import GoodsManageLayout from "../layout/GoodsManageLayout";
import AdminTrainViewLayout from "../layout/AdminTrainViewLayout";
Vue.use(VueRouter);
const routes = [
    {
        path: "/admin",
        redirect: "/admin/education/index",
        component: AdminLayout,
        name: "admin",
        children: [
            {
                path: "/admin/education",
                name: "adminEducational",
                component: AdminEducationLayout,
                children: [
                    {
                        path: "/admin/education/index",
                        name: "adminEducationIndex",
                        component: () => import("../views/admin/EducationManage.vue"),
                        meta: {
                            title: "学院管理",
                        },
                    },
                    {
                        path: "/admin/education/administrator",
                        name: "adminEducationAdministratorManage",
                        component: () => import("../views/admin/AdministratorManage.vue"),
                        meta: {
                            title: "管理员管理",
                        },
                    },
                    {
                        path: "/admin/education/enterprise",
                        name: "adminEducationEnterprise",
                        component: () => import("../views/admin/EnterpriseManage.vue"),
                        meta: {
                            title: "企业管理",
                        },
                    },
                ],
            },
            // 总管理员--脚本
            {
                path: "/admin/script",
                name: "adminScript",
                component: AdminScriptLayout,
                children: [
                    {
                        path: "/admin/script/classification",
                        name: "adminScriptClassification",
                        component: () => import("../views/admin/ClassificationManage.vue"),
                        meta: {
                            title: "脚本管理",
                        },
                    },
                    {
                        path: "/admin/script/index",
                        name: "scriptIndex",
                        component: AdminScriptViewLayout,
                        children: [
                            {
                                path: "/admin/script/index",
                                name: "adminScriptIndex",
                                component: () => import("../views/admin/ScriptManage.vue"),
                                meta: {
                                    title: "脚本创作",
                                },
                            },
                            {
                                path: "/admin/script/view/creation",
                                name: "adminViewScriptCreation",
                                component: () => import("../views/admin/adminViewScriptCreation"),
                                meta: {
                                    title: "查看脚本",
                                },
                            },
                        ],
                    },
                ],
            },
            // 总管理员--实训管理
            {
                path: "/admin/train",
                name: "adminTrain",
                component: AdminTrainLayout,
                children: [
                    {
                        path: "/admin/train/classification",
                        name: "adminTrainClassification",
                        component: () => import("../views/admin/TrainClassManage.vue"),
                        meta: {
                            title: "实训分类",
                        },
                    },
                    {
                        path: "/admin/train/list",
                        name: "adminTrainList",
                        component: () => import("../views/admin/TrainList.vue"),
                        meta: {
                            title: "实训列表",
                        },
                    },
                    {
                        path: "/admin/train/detail",
                        name: "adminTrainDetail",
                        component: () => import("../views/admin/TrainDetail.vue"),
                        meta: {
                            title: "实训详情",
                        },
                    },
                    {
                        path: "/admin/train/createtrain",
                        name: "adminCreateTrain",
                        component: () => import("../views/admin/CreateTrain.vue"),
                        meta: {
                            title: "创建实训",
                        },
                    },
                    // {
                    //     path: '/admin/train/list',
                    //     name: 'trainList',
                    //     component: AdminTrainViewLayout,
                    //     children: [
                    //
                    //         {
                    //             path: '/admin/train/list',
                    //             name: 'adminTrainList',
                    //             component: () => import('../views/admin/TrainList.vue'),
                    //             meta: {
                    //                 title: '实训列表',
                    //                 tabName: 'adminTrainList'
                    //             }
                    //         },
                    //         {
                    //             path: '/admin/train/detail',
                    //             name: 'adminTrainDetail',
                    //             component: () => import('../views/admin/TrainDetail.vue'),
                    //             meta: {
                    //                 title: '实训详情',
                    //                 tabName: 'adminTrainList'
                    //             }
                    //         },
                    //
                    //     ]
                    // },
                ],
            },
            // 总管理员--任务
            {
                path: "/admin/task",
                name: "adminTask",
                component: AdminTaskLayout,
                children: [
                    {
                        path: "/admin/train/classifies",
                        name: "adminTrainClassifies",
                        component: () => import("../views/admin/ClassifiesManage.vue"),
                        meta: {
                            title: "训练分类管理",
                        },
                    },
                    {
                        path: "/admin/task/classifies",
                        name: "adminTaskClassifies",
                        component: () => import("../views/admin/ClassifiesManage.vue"),
                        meta: {
                            title: "任务分类管理",
                        },
                    },
                    {
                        path: "/admin/task/index",
                        name: "adminTaskIndex",
                        component: () => import("../views/admin/TaskManage.vue"),
                        meta: {
                            title: "任务管理",
                        },
                    },
                    {
                        path: "/admin/newTask/index",
                        name: "AdminNewTaskIndex",
                        component: () => import("../views/admin/TaskCenter.vue"),
                        meta: {
                            title: "任务中心",
                        },
                    },
                    {
                        path: "/admin/companyTraining/index",
                        name: "AdminCompanyTrainingIndex",
                        component: () => import("../views/admin/CompanyTaining.vue"),
                        meta: {
                            title: "企业训练",
                        },
                    },
                    {
                        path: "/admin/companyTraining/register",
                        name: "AdminCompanyTrainingRegister",
                        component: () => import("../views/admin/CompanyTrainingRegister.vue"),
                        meta: {
                            title: "报名列表",
                        },
                    },
                    {
                        path: "/admin/companyTraining/port",
                        name: "AdminCompanyTrainingPort",
                        component: () => import("../views/admin/CompanyTrainingPort.vue"),
                        meta: {
                            title: "查看作品",
                        },
                    },
                    {
                        path: "/admin/companyTraining/port/detail",
                        name: "AdminCompanyTrainingPortDetail",
                        component: () => import("../views/admin/CompanyTrainingPortDetail.vue"),
                        meta: {
                            title: "作品详情",
                        },
                    },
                    {
                        path: "/admin/teacherTraining/index",
                        name: "AdminTeacherTrainingIndex",
                        component: () => import("../views/admin/TeacherTraining.vue"),
                        meta: {
                            title: "教师训练",
                        },
                    },{
                        path: "/admin/teacherTraining/detial",
                        name: "AdminTeacherTrainingDetial",
                        component: () => import("../views/admin/TeacherTrainDetial.vue"),
                        meta: {
                            title: "查看详情",
                        },
                    },
                    {
                        path: "/admin/teacherTraining/studentDetial",
                        name: "AdminTeacherTrainingStudentDetiall",
                        component: () => import("../views/admin/TeacherTrainStudentDetial.vue"),
                        meta: {
                            title: "学生附件详情",
                        },

                    }
                ],
            },
            // 管理员-任务详情-新任务模块
            {
                path: "/admin/newTask/detail",
                name: "AdminNewTaskDetail",
                component: () => import("../views/company/new-task/TaskDetail.vue"),
                meta: {
                    title: "任务详情",
                },
            },
            // 总管理员--商品管理
            {
                path: "/admin/goodsManage",
                name: "adminGoodsManage",
                component: GoodsManageLayout,
                children: [
                    {
                        path: "/admin/goodsManage/promote",
                        name: "adminGoodsManagePromote",
                        component: () => import("../views/admin/GoodsPromote"),
                        meta: {
                            title: "商品推广",
                            tabName: "adminGoodsManagePromote",
                        },
                    },
                    {
                        path: "/admin/goodsManage/list",
                        name: "adminGoodsManageList",
                        component: () => import("../views/admin/GoodsManage"),
                        meta: {
                            title: "商品列表",
                            tabName: "adminGoodsManageList",
                        },
                    },
                    {
                        path: "/admin/goodsManage/create",
                        name: "adminGoodsManageCreate",
                        component: () => import("../views/admin/GoodsCreate"),
                        meta: {
                            title: "添加商品",
                            tabName: "adminGoodsManageList",
                        },
                    },
                ],
            },
            // 总管理员--财务
            // {
            //     path: '/admin/finance',
            //     name: 'adminFinance',
            //     component: AdminFinanceLayout,
            //     children: [
            //         {
            //             path: '',
            //             name: 'adminTaskClassifies',
            //             component: () => import('../views/admin/ClassifiesManage.vue'),
            //             meta: {
            //                 title: '分类管理'
            //             }
            //         },
            //     ]
            // },
            // 总管理员--帮助中心
            {
                path: "/admin/help",
                name: "adminHelp",
                component: AdminHelpLayout,
                children: [
                    {
                        path: "/admin/help/classifies",
                        name: "adminHelpClassifies",
                        component: () => import("../views/admin/HelpClassifiesManage.vue"),
                        meta: {
                            title: "分类管理",
                        },
                    },
                    {
                        path: "/admin/help/index",
                        name: "adminHelpIndex",
                        component: () => import("../views/admin/HelpCenter.vue"),
                        meta: {
                            title: "帮助管理",
                        },
                    },
                    {
                        path: "/admin/help/video",
                        name: "adminHelpVideo",
                        component: () => import("../views/admin/HelpVideo.vue"),
                        meta: {
                            title: "视频帮助",
                        },
                    },
                ],
            },
            {
                path: "/admin/announcement",
                name: "adminAnnouncement",
                component: () => import("../views/admin/AnnouncementManage.vue"),
                meta: {
                    title: "公告管理",
                },
            },
            // 总管理员--创建帮助
            {
                path: "/admin/help/create",
                name: "createHelp",
                component: () => import("../components/helpCenter/CreateHelp.vue"),
                meta: {
                    title: "创建帮助",
                },
            },
            // 总管理员--帮助详情
            {
                path: "/admin/help/detail",
                name: "helpDetail",
                component: () => import("../components/helpCenter/HelpDetail.vue"),
                meta: {
                    title: "帮助详情",
                },
            },
        ],
    },
    {
        path: "/data/spectaculars",
        name: "dataSpectaculars",
        component: () => import("../views/spectaculars/dataSpectaculars.vue"),
        meta: {
            title: "数据看板",
        },
    },
    {
        path: "/school",
        redirect: "/school/education/index",
        component: SchoolLayout,
        name: "teacher",
        children: [
            {
                path: "/school/education/index",
                name: "schoolEducation",
                component: SchoolEducationLayout,
                children: [
                    {
                        path: "/school/education/index",
                        name: "schoolEducationIndex",
                        component: () => import("../views/school/EducationManage"),
                        meta: {
                            title: "专业管理",
                        },
                    },
                    {
                        path: "/school/education/teacher",
                        name: "schoolEducationTeacher",
                        component: () => import("../views/school/TeacherManage"),
                        meta: {
                            title: "教师管理",
                        },
                    },
                    {
                        path: "/school/education/class",
                        name: "schoolEducationClass",
                        component: () => import("../views/school/ClassManage.vue"),
                        meta: {
                            title: "班级管理",
                        },
                    },
                    {
                        path: "/school/education/student",
                        name: "schoolEducationStudent",
                        component: () => import("../views/school/StudentManage"),
                        meta: {
                            title: "学生管理",
                        },
                    },
                ],
            },
        ],
    },
    {
        path: "/",
        name: "Login",
        component: () => import("../views/student/Login.vue"),
        meta: {
            title: "学生端登录",
        },
    },
    {
        path: "/admin/login",
        name: "adminLogin",
        component: () => import("../views/Login.vue"),
        meta: {
            title: "管理员端登录",
        },
    },
    {
        path: "/teacher",
        redirect: "/teacher/login",
    },
    {
        path: "/teacher/login",
        name: "teacherLogin",
        component: () => import("../views/teacher/Login.vue"),
        meta: {
            title: "教师端登录",
        },
    },
    {
        path: "/company/login",
        name: "companyLogin",
        component: () => import("../views/company/Login.vue"),
        meta: {
            title: "企业端登录",
        },
    },
    {
        path: "/company",
        redirect: "/company/login",
    },
    {
        path: "/student",
        redirect: "/student/shortvideo",
        component: StudentLayout,
        name: "student",
        children: [
            {
                path: "/student/account/index",
                name: "studentAccount",
                component: StudentShortLayout,
                children: [
                    {
                        path: "/student/works/index",
                        name: "studentWorksIndex",
                        component: () => import("../views/student/creativecenter/WorkBench.vue"),
                        meta: {
                            title: "工作台",
                        },
                    },
                    {
                        path: "/student/account/index",
                        name: "studentAccountIndex",
                        component: () => import("../views/student/creativecenter/AccountManage.vue"),
                        // component: () => import('../views/student/creativecenter/AccountManage_new'),
                        meta: {
                            title: "账号管理",
                        },
                    },
                    {
                        path: "/student/interactive/index",
                        name: "studentInteractiveIndex",
                        component: () => import("../views/student/creativecenter/InteractiveManage.vue"),
                        meta: {
                            title: "互动管理",
                        },
                    },
                    {
                        path: "/student/data/details",
                        name: "studentDataDetails",
                        component: () => import("../views/student/creativecenter/AccountDataDetails.vue"),
                        meta: {
                            title: "账号详情",
                        },
                    },
                    {
                        path: "/student/data/finishTask",
                        name: "studentDataFinishTask",
                        component: () => import("../views/student/creativecenter/FinishTask"),
                        meta: {
                            title: "完成任务",
                        },
                    },
                    {
                        path: "/student/cultural/creation/details",
                        name: "studentCulturalCreationDetails",
                        component: () => import("../views/student/creativecenter/CulturalCreationDetails"),
                        meta: {
                            title: "文创详情",
                        },
                    },
                    {
                        path: "/student/graphic/creation",
                        name: "studentGraphicCreation",
                        component: () => import("../views/student/creativecenter/GraphicCreation1"),
                        meta: {
                            title: "图文创作",
                        },
                    },
                    {
                        path: "/student/graphic/index",
                        name: "studentGraphicIndex",
                        component: () => import("../views/student/creativecenter/GraphicIndex1"),
                        meta: {
                            title: "图文管理",
                        },
                    },
                    {
                        path: "/student/graphic/preview",
                        name: "studentGraphicPreview",
                        component: () => import("../views/teacher/audit/ArticlePreview.vue"),
                        meta: {
                            title: "文章预览",
                        },
                    },
                    // {
                    //     path: '/student/graphic/creation1',
                    //     name: 'studentGraphicCreation',
                    //     component: () => import('../views/student/creativecenter/GraphicCreation'),
                    //     meta: {
                    //         title: '图文创作1'
                    //     }
                    // },
                    {
                        path: "/student/video/management",
                        name: "studentVideoManagement",
                        component: () => import("../views/student/creativecenter/VideoManagement.vue"),
                        meta: {
                            title: "视频管理",
                        },
                    },
                    {
                        path: "/student/video/managementNew",
                        name: "studentVideoManagementNew",
                        component: () => import("../views/student/creativecenter/VideoManagementNew.vue"),
                        meta: {
                            title: "作品管理",
                        },
                    },
                    {
                        path: "/student/video/publishWorks",
                        name: "studentPublishWorks",
                        component: () => import("../views/student/creativecenter/PublishWorks.vue"),
                        meta: {
                            title: "发布作品",
                        },
                    },
                    {
                        path: "/student/video/publishVideo",
                        name: "studentPublishVideo",
                        component: () => import("../views/student/creativecenter/PublishVideo.vue"),
                        meta: {
                            title: "发布视频",
                        },
                    },
                    {
                        path: "/student/live/management",
                        name: "studentLiveManagement",
                        component: () => import("../views/student/creativecenter/LiveManagement.vue"),
                        meta: {
                            title: "直播管理",
                        },
                    },
                    {
                        path: "/student/video/publish",
                        name: "studentVideoPublish",
                        component: () => import("../views/student/creativecenter/v1/VideoPublish.vue"),
                        meta: {
                            title: "视频发布",
                        },
                    },
                    // {
                    //     path: '/student/short/index',
                    //     name: 'studentShortIndex',
                    //     component: () => import('../views/student/creativecenter/ShortVideoManage'),
                    //     meta: {
                    //         title: '短视频创作'
                    //     }
                    // },
                    {
                        path: "/student/video/clip/Index",
                        name: "studentVideoClipIndex",
                        component: StudentScriptLayout,
                        children: [
                            {
                                path: "/student/video/clip",
                                name: "studentVideoClip",
                                component: () => import("../views/student/creativecenter/VideoClip.vue"),
                                meta: {
                                    title: "视频剪辑",
                                },
                            },
                            {
                                path: "/student/video/editor",
                                name: "studentVideoEditor",
                                component: () => import("../views/student/creativecenter/VideoEditor.vue"),
                                meta: {
                                    title: "云剪辑",
                                },
                            },
                        ],
                    },
                    {
                        path: "/student/InteractiveManagement",
                        name: "studentInteractiveManagement",
                        component: StudentScriptLayout,
                        children: [
                            {
                                path: "/student/InteractiveManagement/index",
                                name: "studentInteractiveManagementIndex",
                                component: () => import("../views/student/creativecenter/InteractiveManagementIndex.vue"),
                                children: [
                                    {
                                        path: "/student/InteractiveManagement/CommentManagement",
                                        name: "studentCommentManagement",
                                        component: () => import("../views/student/creativecenter/CommentManagement.vue"),
                                        meta: {
                                            title: "评论管理",
                                        },
                                    },
                                    {
                                        path: "/student/InteractiveManagement/PrivateMessageManagement",
                                        name: "studentPrivateMessageManagement",
                                        component: () => import("../views/student/creativecenter/PrivateMessageManagement.vue"),
                                        meta: {
                                            title: "私信管理",
                                        },
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        path: "/student/DataCenter",
                        name: "studentDataCenter",
                        component: StudentScriptLayout,
                        children: [
                            {
                                path: "/student/dataCenter/BusinessAnalysis",
                                name: "studentBusinessAnalysis",
                                component: () => import("../views/student/creativecenter/dataCenter/BusinessAnalysis.vue"),
                                meta: {
                                    title: "经营分析",
                                },
                            },
                            {
                                path: "/student/dataCenter/ContentAnalysis",
                                name: "studentContentAnalysis",
                                component: () => import("../views/student/creativecenter/dataCenter/ContentAnalysis.vue"),
                                meta: {
                                    title: "内容分析",
                                },
                            },
                            {
                                path: "/student/dataCenter/ContentDetail",
                                name: "studentContentDetail",
                                component: () => import("../views/student/creativecenter/dataCenter/ContentDetail.vue"),
                                meta: {
                                    title: "分析详情",
                                },
                            },
                            {
                                path: "/student/dataCenter/FanPortait",
                                name: "studentFanPortrait",
                                component: () => import("../views/student/creativecenter/dataCenter/FanPortrait.vue"),
                                meta: {
                                    title: "粉丝画像",
                                },
                            },
                        ],
                    },
                    {
                        path: "/student/dataAnalysis/index",
                        name: "studentDataAnalysis",
                        component: StudentDataLayout,
                        children: [
                            {
                                path: "/student/dataAnalysis/index",
                                name: "studentDataAnalysisIndex",
                                component: () => import("../views/student/creativecenter/DataAnalysis"),
                                meta: {
                                    title: "数据管理",
                                },
                            },
                            {
                                path: "/student/dataAnalysis/create",
                                name: "studentDataAnalysisCreate",
                                component: () => import("../views/student/creativecenter/CreateDataAnalysis"),
                                meta: {
                                    title: "创建数据",
                                },
                            },
                            {
                                path: "/student/dataAnalysis/detail",
                                name: "studentDataAnalysisDetail",
                                component: () => import("../views/student/creativecenter/DataAnalysisDetail"),
                                meta: {
                                    title: "数据分析详情",
                                },
                            },
                        ],
                    },
                    {
                        path: "/student/productPromotion/index",
                        name: "studentProductPromotion",
                        component: StudentDataLayout,
                        children: [
                            {
                                path: "/student/productPromotion/index",
                                name: "studentProductPromotionIndex",
                                component: () => import("../views/student/creativecenter/ProductPromotion"),
                                meta: {
                                    title: "商品推广",
                                },
                            },
                            {
                                path: "/student/productPromotion/PIDTao",
                                name: "studentProductPromotionPIDTao",
                                component: () => import("../views/student/creativecenter/PIDTaoTutorial"),
                                meta: {
                                    title: "获取淘宝PID",
                                },
                            },
                            {
                                path: "/student/productPromotion/PIDPdd",
                                name: "studentProductPromotionPIDPdd",
                                component: () => import("../views/student/creativecenter/PIDPddTutorial"),
                                meta: {
                                    title: "获取拼多多PID",
                                },
                            },
                            {
                                path: "/student/productPromotion/PIDJd",
                                name: "studentProductPromotionPIDJd",
                                component: () => import("../views/student/creativecenter/PIDJdTutorial"),
                                meta: {
                                    title: "获取京东PID",
                                },
                            },
                            {
                                path: "/student/productPromotion/index1",
                                name: "studentProductPromotionIndex1",
                                component: () => import("../views/student/creativecenter/ProductPromotion1"),
                                meta: {
                                    title: "商品推广旧版",
                                },
                            },
                            {
                                path: "/student/mySelectionLibrary",
                                name: "studentMySelectionLibrary",
                                component: () => import("../views/student/creativecenter/MySelectionLibrary"),
                                meta: {
                                    title: "我的选品库",
                                },
                            },
                            {
                                path: "/student/immediatePromotion",
                                name: "studentImmediatePromotion",
                                component: () => import("../views/student/creativecenter/ImmediatePromotion"),
                                meta: {
                                    title: "立即推广",
                                },
                            },
                            {
                                path: "/student/collectCoupons",
                                name: "studentCollectCoupons",
                                component: () => import("../views/student/creativecenter/CollectCoupons"),
                                meta: {
                                    title: "领优惠券",
                                },
                            },
                        ],
                    },
                    {
                        path: "/student/script/creation/Index",
                        name: "studentScriptCreationIndex",
                        component: StudentScriptLayout,
                        children: [
                            {
                                path: "/student/script/creation",
                                name: "studentScriptCreation",
                                component: () => import("../views/student/creativecenter/ScriptCreation"),
                                meta: {
                                    title: "脚本创作",
                                },
                            },
                            {
                                path: "/student/script/view/creation",
                                name: "studentViewScriptCreation",
                                component: () => import("../views/student/creativecenter/StudentViewScriptCreation"),
                                meta: {
                                    title: "查看脚本",
                                },
                            },
                        ],
                    },
                    {
                        path: "/student/works/announcement",
                        name: "studentWorksAnnouncement",
                        component: () => import("../views/student/creativecenter/AnnouncementDetail"),
                        meta: {
                            title: "平台公告",
                        },
                    },
                    {
                        path: "/student/works/helpcenter",
                        name: "studentWorksHelpCenter",
                        component: () => import("../views/student/creativecenter/HelpCenter"),
                        meta: {
                            title: "帮助中心",
                        },
                    },
                    {
                        path: "/student/works/setting",
                        name: "studentWorksHelpCenter",
                        component: () => import("../views/student/creativecenter/Setting"),
                        meta: {
                            title: "设置",
                        },
                    },
                    {
                        path: "/student/works/fanChart",
                        name: "studentWorksFanChart",
                        component: () => import("../views/student/creativecenter/FanChart.vue"),
                        meta: {
                            title: "粉丝排行榜",
                        },
                    },
                ],
            },
            // 训练中心 - 原任务中心
            {
                path: "/student/task/index",
                name: "studentTask",
                component: StudentShortLayout,
                children: [
                    {
                        path: "/student/task/index",
                        name: "studentTaskIndex",
                        component: () => import("../views/student/taskcenter/MissionHall"),
                        meta: {
                            title: "训练大厅",
                        },
                    },
                    {
                        path: "/student/task/detail",
                        name: "studentTaskDetail",
                        component: () => import("../components/taskCenter/taskDetail/TaskDetail.vue"),
                        meta: {
                            title: "训练详情",
                            activeName: "studentTaskIndex",
                        },
                    },
                    {
                        path: "/student/task/annexDetails",
                        name: "studenTaskDetailtAnnexDetails",
                        component: () => import("../components/taskCenter/taskDetail/AnnexDetails.vue"),
                        meta: {
                            title: "学生提交详情",
                            activeName: "studentTaskIndex",
                        },
                    },
                    {
                        path: "/student/task/analysedetail",
                        name: "studenTaskDetailtAnalyseDetail",
                        component: () => import("../components/taskCenter/taskDetail/analyseDetail.vue"),
                        meta: {
                            title: "数据分析详情",
                        },
                    },
                    {
                        path: "/student/task/companyUserIndex",
                        name: "studentCompanyUserIndex",
                        component: () => import("../components/taskCenter/CompanyUserIndex.vue"),
                        meta: {
                            title: "企业用户首页",
                            activeName: "studentTaskIndex",
                        },
                    },
                    {
                        path: "/student/goods/index",
                        name: "studentGoodsIndex",
                        component: () => import("../views/student/taskcenter/GoodsHall"),
                        meta: {
                            title: "商品大厅",
                        },
                    },
                ],
            },
            // 任务中心-新
            {
                path: "/student/newTask",
                name: "studentNewTask",
                component: StudentShortLayout,
                children: [
                    {
                        path: "/student/newTask/index",
                        name: "StudentNewTaskIndex",
                        component: () => import("../views/student/new-task/NewTaskCenter.vue"),
                        meta: {
                            title: "任务中心",
                        },
                    },
                    {
                        path: "/student/newTask/list",
                        name: "StudentNewTaskList",
                        component: () => import("../views/student/new-task/TaskList.vue"),
                        meta: {
                            title: "我的任务",
                        },
                    },
                ],
            },
            {
                path: "/student/newTask/detail",
                name: "StudentNewTaskDetail",
                component: () => import("../views/company/new-task/TaskDetail.vue"),
                meta: {
                    title: "任务详情",
                    noUser: true,
                },
            },
            //自媒体库
            {
                path: "/student/hot/scripts",
                name: "studentHotScripts",
                component: StudentShortLayout,
                children: [
                    {
                        path: "/student/hot/scripts",
                        name: "studentHot",
                        component: () => import("../views/student/medium/HotScripts.vue"),
                        meta: {
                            title: "热门脚本",
                        },
                    },
                    {
                        path: "/student/hot/scriptsDetail",
                        name: "studentHotScriptDetail",
                        component: () => import("../views/student/medium/HotScriptsDetail"),
                        meta: {
                            title: "热门脚本详情",
                        },
                    },
                    {
                        path: "/student/hot/topic",
                        name: "studentHotTopic",
                        component: () => import("../views/student/medium/HotTopic"),
                        meta: {
                            title: "热门话题",
                        },
                    },
                    {
                        path: "/student/hot/articles",
                        name: "studentHotArticles",
                        component: () => import("../views/student/medium/HotArticles"),
                        meta: {
                            title: "热门文章",
                        },
                    },
                    {
                        path: "/student/hot/broadcaster",
                        name: "studentHotBroadcaster",
                        component: () => import("../views/student/medium/HotBroadcaster.vue"),
                        meta: {
                            title: "热门播主",
                        },
                    },
                    {
                        path: "/tiktok/hot/video",
                        name: "tiktokHotVideo",
                        component: () => import("../views/student/medium/HotVideo.vue"),
                        meta: {
                            title: "热门视频",
                        },
                    },
                    {
                        path: "/student/hot/video",
                        name: "studentHotVideo",
                        component: () => import("../views/student/medium/HotVideo1.vue"),
                        meta: {
                            title: "热门视频",
                        },
                    },
                    {
                        path: "/student/hot/HotTopicNew",
                        name: "studentHotHotTopicNew",
                        component: () => import("../views/student/medium/HotTopicNew.vue"),
                        meta: {
                            title: "热门话题",
                        },
                    },
                    {
                        path: "/student/hot/HotItem",
                        name: "studentHotHotItem",
                        component: () => import("../views/student/medium/HotItem.vue"),
                        meta: {
                            title: "热门道具",
                        },
                    },
                    {
                        path: "/student/hot/TiktokRanking",
                        name: "studentHotHotTiktokRanking",
                        component: () => import("../views/student/medium/TiktokRanking.vue"),
                        meta: {
                            title: "抖音排行榜",
                        },
                    },
                    {
                        path: "/student/hot/hotspot",
                        name: "studentHotspot",
                        component: () => import("../views/student/medium/Hotspot.vue"),
                        meta: {
                            title: "创作热点",
                        },
                    },
                    {
                        path: "/student/hot/videoDetail",
                        name: "studentHotVideoDetail",
                        component: () => import("../views/student/medium/VideoDetail"),
                        meta: {
                            title: "视频详情",
                        },
                    },
                    {
                        path: "/student/hot/authorDetail",
                        name: "studentAuthorDetail",
                        component: () => import("../views/student/medium/AuthorDetail"),
                        meta: {
                            title: "播主详情",
                        },
                    },
                    {
                        path: "/student/hot/authorVideoDetail",
                        name: "studentAuthorVideoDetail",
                        component: () => import("../views/student/medium/AuthorVideoDetail"),
                        meta: {
                            title: "播主视频详情",
                        },
                    },
                    {
                        path: "/student/hot/media",
                        name: "mediaData",
                        component: () => import("../views/student/medium/MediaData.vue"),
                        meta: {
                            title: "媒体实时数据",
                        },
                    },
                ],
            },
            //电商分析
            {
                path: "/student/ds/video/ranking",
                name: "studentDsVideoRanking",
                component: StudentShortLayout,
                children: [
                    {
                        path: "/student/ds/video/rank",
                        name: "studentDsVideo",
                        component: () => import("../views/student/ec/DsVideoRank.vue"),
                        meta: {
                            title: "电商视频排行",
                        },
                    },
                    {
                        path: "/student/ds/video/videodetail",
                        name: "studentDsVideoDetail",
                        component: () => import("../views/student/ec/DsVideoDetail.vue"),
                        meta: {
                            title: "视频详情",
                        },
                    },
                    {
                        path: "/student/dy/products/rank",
                        name: "studentDyProductsRank",
                        component: () => import("../views/student/ec/DyProductsRank.vue"),
                        meta: {
                            title: "抖音商品排行",
                        },
                    },
                    {
                        path: "/student/tb/promotion/rank",
                        name: "studentTbProductsRank",
                        component: () => import("../views/student/ec/TbProductsRank"),
                        meta: {
                            title: "淘宝推广排行",
                        },
                    },
                    {
                        path: "/student/tb/goodDetail",
                        name: "studentTbGoodDetail",
                        component: () => import("../views/student/ec/GoodDetail"),
                        meta: {
                            title: "淘宝商品详情",
                        },
                    },
                    {
                        path: "/student/dy/goodDetail",
                        name: "studentTbGoodDetail",
                        component: () => import("../views/student/ec/DYGoodDetail.vue"),
                        meta: {
                            title: "抖音商品详情",
                        },
                    },
                    {
                        path: "/student/dy/favorite",
                        name: "studentDyFavorite",
                        component: () => import("../views/student/ec/DyFavorite"),
                        meta: {
                            title: "抖音好物排行",
                        },
                    },
                    {
                        path: "/student/ds/sales/rank",
                        name: "studentDsSalesRank",
                        component: () => import("../views/student/ec/DsSalesRank"),
                        meta: {
                            title: "电商达人销量排行",
                        },
                    },

                    {
                        path: "/student/ds/sales/rank/details",
                        name: "studentDsSalesRankDetails",
                        component: () => import("../views/student/ec/DsSalesRankDetails.vue"),
                        meta: {
                            title: "电商达人销量排行查看详情",
                        },
                    },
                    {
                        path: "/student/ds/video/details",
                        name: "studentDsVideoDetails",
                        component: () => import("../views/student/ec/DsVideoDetails"),
                        meta: {
                            title: "视频详情",
                        },
                    },
                ],
            },
            {
                path: "/student/help/detail",
                name: "studentHelpDetail",
                component: () => import("../components/helpCenter/StudentHelpDetail.vue"),
                meta: {
                    title: "帮助信息详情",
                },
            },
            //招聘中心
            {
                path: "/student/recruitmentCenter",
                name: "studentRecruitmentCenter",
                component: StudentShortLayout,
                redirect: "/student/recruitmentCenter/company",
                children: [
                    {
                        path: "/student/recruitmentCenter/company",
                        name: "studentRecruitmentCenterCompany",
                        component: () => import("../views/student/recruitmentCenter/company/Company.vue"),
                        meta: {
                            title: "公司",
                            parent_name: "studentRecruitmentCenter",
                            class: ["no-padding"],
                        },
                    },
                    {
                        path: "/student/recruitmentCenter/companyDetial",
                        name: "studentRecruitmentCenterCompanyDetial",
                        component: () => import("../views/student/recruitmentCenter/company/CompanyDetial.vue"),
                        meta: {
                            title: "公司详情",
                            parent_name: "studentRecruitmentCenter",
                            class: ["no-padding"],
                            activeName: "studentRecruitmentCenterCompany",
                        },
                    },
                    {
                        path: "/student/recruitmentCenter/taskDetial",
                        name: "studentRecruitmentCenterTaskDetial",
                        component: () => import("../views/student/recruitmentCenter/company/TaskDetial.vue"),
                        meta: {
                            title: "任务详情",
                            parent_name: "studentRecruitmentCenter",
                        },
                    },
                    {
                        path: "/student/recruitmentCenter/jobDetails",
                        name: "studentRecruitmentCenterJobDetails",
                        component: () => import("../views/student/recruitmentCenter/company/JobDetails.vue"),
                        meta: {
                            title: "职位详情",
                            parent_name: "studentRecruitmentCenter",
                        },
                    },
                    {
                        path: "/student/recruitmentCenter/trainDetial",
                        name: "studentRecruitmentCenterTrainDetial",
                        component: () => import("../views/student/recruitmentCenter/company/TrainDetial.vue"),
                        meta: {
                            title: "训练详情",
                            parent_name: "studentRecruitmentCenter",
                        },
                    },

                    {
                        path: "/student/recruitmentCenter/job",
                        name: "studentRecruitmentCenterJob",
                        component: () => import("../views/student/recruitmentCenter/job/JobIndex.vue"),
                        meta: {
                            title: "职位",
                            parent_name: "studentRecruitmentCenter",
                        },
                    },

                    {
                        path: "/student/recruitmentCenter/job/detail",
                        name: "studentRecruitmentCenterJobDetail",
                        component: () => import("../views/student/recruitmentCenter/job/JobDetail.vue"),
                        meta: {
                            title: "职位详情",
                            parent_name: "studentRecruitmentCenter",
                            activeName: "studentRecruitmentCenterJob",
                        },
                    },
                ],
            },

            // 个人简历
            {
                path: "/student/recruitmentCenter/personalResume",
                name: "studentRecruitmentCenterPersonalResume",
                component: () => import("../views/student/recruitmentCenter/personalResume/PersonalResume.vue"),
                meta: {
                    title: "个人简历",
                },
            },
            {
                path: "/student/recruitmentCenter/myJob",
                name: "studentRecruitmentCenterMyJob",
                component: () => import("../views/student/recruitmentCenter/personalResume/MyJob.vue"),
                meta: {
                    title: "我的职位",
                },
            },

            //   {
            //     path:'/TeacherLogin',
            //     name:'teacherLogin',
            //     component: () => import('./../views/TeacherLogin')
            //   }
            //个人中心
        ],
    },
    {
        path: "/teacher/shortteacher",
        component: TeacherLayout,
        name: "teacher",

        children: [
            {
                path: "/teacher/account/index",
                name: "teacherAudit",
                component: TeacherShortLayout,
                children: [
                    {
                        path: "/teacher/account/index",
                        name: "teacherAccountIndex",
                        component: () => import("../views/teacher/audit/AccountAudit.vue"),
                        meta: {
                            title: "账号审核",
                        },
                    },
                    {
                        path: "/teacher/account/video",
                        name: "teacherAccountVideoAudit",
                        component: () => import("../views/teacher/audit/VideoAudit.vue"),
                        meta: {
                            title: "视频审核",
                        },
                    },
                    {
                        path: "/teacher/account/article",
                        name: "teacherAccountArticleAudit",
                        component: () => import("../views/teacher/audit/ArticleAudit.vue"),
                        meta: {
                            title: "文章审核",
                        },
                    },
                    {
                        path: "/teacher/account/article/articlePreview",
                        name: "teacherArticlePreview",
                        component: () => import("../views/teacher/audit/ArticlePreview.vue"),
                        meta: {
                            title: "文章预览",
                        },
                    },
                ],
            },
            {
                path: "/teacher/taskcenter/index",
                name: "teacherManagement",
                component: TeacherShortLayout,
                children: [
                    {
                        path: "/teacher/taskcenter/index",
                        name: "taskCenterIndex",
                        component: () => import("../views/teacher/management/taskCenter"),
                        meta: {
                            title: "任务中心",
                        },
                    },
                    {
                        path: "/teacher/taskcenter/viewdetails",
                        name: "taskcenterViewDetails",
                        component: () => import("../views/teacher/management/viewDetails.vue"),
                        meta: {
                            title: "查看详情",
                        },
                    },
                    {
                        path: "/teacher/taskcenter/annexdetails",
                        name: "taskcenterAnnexDetails",
                        component: () => import("../views/teacher/management/AnnexDetails.vue"),
                        meta: {
                            title: "学生附件详情",
                        },
                    },
                    {
                        path: "/teacher/taskcenter/analysedetail",
                        name: "analyseDetail",
                        component: () => import("../views/teacher/management/analyseDetail"),
                        meta: {
                            title: "数据分析详情",
                        },
                    },
                    {
                        path: "/teacher/taskcenter/taskIndex",
                        name: "taskIndex",
                        component: () => import("../views/teacher/management/taskIndex.vue"),
                        meta: {
                            title: "训练中心",
                        },
                    },
                ],
            },
            {
                path: "/teacher/newTask",
                name: "teacherNewTask",
                component: TeacherShortLayout,
                children: [
                    {
                        path: "/teacher/newTask/index",
                        name: "NewTaskIndex",
                        component: () => import("../views/company/new-task/TaskList.vue"),
                        meta: {
                            title: "任务中心",
                        },
                    },
                    {
                        path: "/teacher/newTask/publish",
                        name: "NewTaskPublish",
                        component: () => import("../views/company/new-task/PublishDemand.vue"),
                        meta: {
                            title: "发布需求",
                        },
                    },

                    {
                        path: "/teacher/newTask/completion",
                        name: "NewTaskCompletion",
                        component: () => import("../views/teacher/studentmang/StudentCompletion.vue"),
                        meta: {
                            title: "完成任务情况",
                        },
                    },
                ],
            },
            {
                path: "/teacher/newTask/detail",
                name: "NewTaskDetail",
                component: () => import("../views/company/new-task/TaskDetail.vue"),
                meta: {
                    title: "任务详情",
                    noUser: true,
                },
            },
            {
                path: "/teacher/studentmang/index",
                name: "teacherStudentMang",
                component: TeacherShortLayout,
                children: [
                    {
                        path: "/teacher/studentmang/index",
                        name: "studentmangIndex",
                        component: () => import("../views/teacher/studentmang/student"),
                        meta: {
                            title: "学生",
                        },
                    },
                    {
                        path: "/teacher/data/details",
                        name: "teacherStuDataDetails",
                        component: () => import("../views/teacher/studentmang/NewDataDetails.vue"),
                        meta: {
                            title: "账号详情",
                        },
                    },
                    {
                        path: "/teacher/account/details",
                        name: "teacherStuAccountDetails",
                        component: () => import("../views/teacher/studentmang/NewAccountDetail.vue"),
                        meta: {
                            title: "账号总览",
                        },
                    },
                ],
            },
        ],
    },
    {
        path: "/company",
        redirect: "/company/shortcompany",
        component: CompanyLayout,
        name: "company",
        children: [
            {
                path: "/company/taskcenter/index",
                name: "companyTaskCenter",
                component: CompanyShortLayout,
                children: [
                    {
                        path: "/company/taskcenter/index/Index",
                        name: "companyTaskCenterIndex",
                        component: CompanyViewLayout,
                        children: [
                            {
                                path: "/company/taskcenter/index",
                                name: "taskCenterIndex",
                                component: () => import("../views/company/task/taskCenter.vue"),
                                meta: {
                                    title: "训练中心",
                                },
                            },
                            {
                                path: "/company/taskcenter/publish",
                                name: "taskCenterPublish",
                                component: () => import("../views/company/task/taskPublish"),
                                meta: {
                                    title: "发布任务",
                                },
                            },
                            {
                                path: "/company/taskcenter/registList",
                                name: "registList",
                                component: () => import("../views/company/task/registList.vue"),
                                meta: {
                                    title: "报名列表",
                                },
                            },
                            {
                                path: "/company/taskcenter/worksList",
                                name: "worksList",
                                component: () => import("../views/company/task/worksList.vue"),
                                meta: {
                                    title: "作品列表",
                                },
                            },
                            {
                                path: "/company/taskcenter/worksDetail",
                                name: "worksDetail",
                                component: () => import("../views/company/task/worksDetails"),
                                meta: {
                                    title: "作品列表-详情",
                                },
                            },
                            {
                                path: "/company/taskcenter/analyseDetail",
                                name: "companyAnalyseDetail",
                                component: () => import("../views/company/task/analyseDetail"),
                                meta: {
                                    title: "数据分析详情",
                                },
                            },
                        ],
                    },
                    {
                        path: "/company/newTask",
                        name: "CompanyNewTask",
                        redirect: "/company/newTask/index",
                        component: CompanyViewLayout,
                        meta: {
                            title: "任务中心",
                        },
                        children: [
                            {
                                path: "/company/newTask/index",
                                name: "CompanyNewTaskIndex",
                                component: () => import("../views/company/new-task/TaskList.vue"),
                                meta: {
                                    title: "任务中心",
                                },
                            },
                            {
                                path: "/company/newTask/publish",
                                name: "CompanyNewTaskPublish",
                                component: () => import("../views/company/new-task/PublishDemand.vue"),
                                meta: {
                                    title: "发布需求",
                                },
                            },
                        ],
                    },

                    {
                        path: "/company/StuExpert/index/Index",
                        name: "companyStuExpertIndex",
                        component: CompanyViewLayout,
                        children: [
                            {
                                path: "/company/StuExpert/index",
                                name: "StuExpertIndex",
                                component: () => import("../views/company/product/StuExpert"),
                                meta: {
                                    title: "学生达人榜",
                                },
                            },
                            {
                                path: "/company/data/picDetails",
                                name: "companyPicDetails",
                                component: () => import("../views/company/expertDetail/picDataDetails"),
                                meta: {
                                    title: "学生数据详情",
                                },
                            },
                            {
                                path: "/company/data/details",
                                name: "companyStuDataDetails",
                                component: () => import("../views/company/expertDetail/AccountDataDetails.vue"),
                                meta: {
                                    title: "账号详情",
                                },
                            },
                        ],
                    },
                    {
                        path: "/company/product/index/Index",
                        name: "companyProductIndex",
                        component: CompanyViewLayout,
                        children: [
                            {
                                path: "/company/product/index",
                                name: "productIndex",
                                component: () => import("../views/company/product/productList"),
                                meta: {
                                    title: "商品列表",
                                },
                            },
                            {
                                path: "/company/product/add",
                                name: "addProduct",
                                component: () => import("../views/company/product/addProducts"),
                                meta: {
                                    title: "添加商品",
                                },
                            },
                        ],
                    },
                    {
                        path: "/company/introduce/index",
                        name: "companyIntroIndex",
                        component: () => import("../views/company/product/companyIntro.vue"),
                        meta: {
                            title: "企业介绍",
                        },
                    },
                    {
                        path: "/company/recruitment/management",
                        name: "RecruitmentManagement",
                        component: () => import("../views/company/product/RecruitmentManagement.vue"),
                        meta: {
                            title: "职位管理",
                        },
                    },
                    {
                        path: "/company/delivery/management",
                        name: "DeliveryManagement",
                        component: () => import("../views/company/product/DeliveryManagement.vue"),
                        meta: {
                            title: "投递管理",
                        },
                    },
                    {
                        path: "/company/interview/management",
                        name: "InterviewManagement",
                        component: () => import("../views/company/product/InterviewManagement.vue"),
                        meta: {
                            title: "面试管理",
                        },
                    },
                    {
                        path: "/company/post/position",
                        name: "PostPosition",
                        component: () => import("../views/company/product/PostPosition.vue"),
                        meta: {
                            title: "发布职位",
                        },
                    },
                ],
            },

            {
                path: "/company/newTask/detail",
                name: "CompanyTaskDetail",
                component: () => import("../views/company/new-task/TaskDetail.vue"),
                meta: {
                    title: "任务详情",
                    noUser: true,
                },
            },
        ],
    },
    {
        path: "/student/dataCenter/ContentDetailCopy",
        name: "studentContentDetailCopy",
        component: () => import("../views/student/creativecenter/dataCenter/ContentDetailCopy.vue"),
        meta: {
            title: "分析详情",
        },
    },
];

const router = new VueRouter({
    mode: "hash",
    base: process.env.BASE_URL,
    routes,
});

router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title;
    }
    next();
});

export default router;
